import _noop from "lodash/noop";
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import * as React from 'react';
import classnames from 'classnames';
import injectStyles from '../jss';
import styles from './NavigationLink.jss';
import { Link } from 'react-router';
var NavigationLink = function NavigationLink(_ref) {
  var _ref$activeExactly = _ref.activeExactly,
    activeExactly = _ref$activeExactly === void 0 ? true : _ref$activeExactly,
    additional = _ref.additional,
    classes = _ref.classes,
    external = _ref.external,
    hideMenu = _ref.hideMenu,
    hideOnDesktop = _ref.hideOnDesktop,
    hideOnMobile = _ref.hideOnMobile,
    id = _ref.id,
    isButton = _ref.isButton,
    isInverse = _ref.isInverse,
    _ref$onClick = _ref.onClick,
    onClick = _ref$onClick === void 0 ? _noop : _ref$onClick,
    rel = _ref.rel,
    _ref$target = _ref.target,
    target = _ref$target === void 0 ? '_blank' : _ref$target,
    text = _ref.text,
    url = _ref.url,
    pathname = _ref.pathname;
  var isActive = !external && url && pathname && (activeExactly ? pathname === url : pathname && pathname.startsWith(url));
  var className = classnames(classes.link, {
    active: isActive,
    activeButton: isButton && isActive,
    additional: additional,
    button: isButton,
    hideOnDesktop: hideOnDesktop,
    hideOnMobile: hideOnMobile,
    inverse: isInverse
  });
  var handleClick = function handleClick() {
    hideMenu();
    onClick();
  };
  var props = {
    className: className,
    id: id,
    key: text,
    onClick: handleClick
  };
  return external ? React.createElement("a", _extends({}, props, {
    href: url,
    target: target,
    rel: rel
  }), text) : React.createElement(Link, _extends({}, props, {
    rel: rel,
    to: url
  }), text);
};
NavigationLink.styleRoot = 'NavigationLink';
NavigationLink.defaultProps = {
  activeExactly: true,
  onClick: _noop,
  target: '_blank'
};
export default injectStyles(styles)(NavigationLink);